export const SQL_ATTRIBUTE_KEYS = ['length', 'precision', 'scale', 'identity', 'defaultKind'];
export const CHARACTER_TYPES = ['VARCHAR', 'VARCHAR2', 'CHAR', 'ENUM'];
export const NUMBER_TYPES = ['INTEGER', 'BIGINT', 'SMALLINT', 'TINYINT', 'DECIMAL', 'NUMBER'];

export function defaultKindFor(attribute) {
    if (attribute.defaultKind) return attribute.defaultKind;
    const known = attribute.type === 'DATE' ? ['SYSDATE', 'CURRENT_DATE'] :
        ['DATETIME', 'TIMESTAMP'].includes(attribute.type) ? ['CURRENT_TIMESTAMP', 'SYSTIMESTAMP', 'LOCALTIMESTAMP'] : [];
    return known.includes(attribute.defaultValue?.trim().toUpperCase()) ? 'expression' : 'literal';
}

export function sqlAttributeData(attribute) {
    return Object.fromEntries(SQL_ATTRIBUTE_KEYS.filter(key => attribute[key] !== undefined).map(key => [key, attribute[key]]));
}

export function validateSqlAttribute(attribute) {
    for (const [key, min, max] of [['length', 1, 4000], ['precision', 1, 38], ['scale', 0, 38]]) {
        if (attribute[key] !== undefined && (!Number.isInteger(attribute[key]) || attribute[key] < min || attribute[key] > max)) {
            throw new Error(`${{ length: 'Longueur', precision: 'Précision', scale: 'Décimales' }[key]} : indiquez un entier entre ${min} et ${max}.`);
        }
    }
    if (attribute.identity !== undefined && typeof attribute.identity !== 'boolean') throw new Error('Auto-incrément invalide.');
    if (attribute.defaultKind !== undefined && !['literal', 'expression'].includes(attribute.defaultKind)) throw new Error('Mode de valeur par défaut invalide.');
    if (['NUMBER', 'DECIMAL'].includes(attribute.type) && (attribute.scale ?? (attribute.type === 'NUMBER' ? 0 : 2)) > (attribute.precision ?? (attribute.type === 'NUMBER' ? 38 : 18))) throw new Error('Les décimales ne peuvent pas dépasser la précision.');
}

export function attributeTypeLabel(attribute) {
    if (CHARACTER_TYPES.includes(attribute.type) && attribute.length !== undefined) return `${attribute.type}(${attribute.length})`;
    if (['DECIMAL', 'NUMBER'].includes(attribute.type) && (attribute.precision !== undefined || attribute.scale !== undefined)) {
        return `${attribute.type}(${attribute.precision ?? (attribute.type === 'NUMBER' ? 38 : 18)},${attribute.scale ?? (attribute.type === 'NUMBER' ? 0 : 2)})`;
    }
    return attribute.type;
}
